export enum ProfessionalSummaryDataType {
    allergies = 'allergies',
    diagnosticDeterminations = 'diagnosticDeterminations',
    episodesAndJournals = 'episodesAndJournals',
    medication = 'medication',
}
